<template>
  <div class="business_service">
    <div class="business" v-for="(item, index) of businessData" :key="index">
      <div class="business_title">{{ item.agencyType }}</div>
      <div class="trademark_box">
        <div
          class="trademark"
          v-for="(el, index) of item.data"
          :key="index"
          @click="imgDetail(el)"
        >
          <img class="trademark_img" :src="el.logo_url" alt />
        </div>
      </div>
    </div>
    <detail-logo
      :dialogVisible="dialogVisible"
      :title="title"
      @closeDialog="closeDialog"
      :detailData="detailData"
    ></detail-logo>
  </div>
</template>
<script>
import DetailLogo from "./components/detailLogo";
import { agencyList, logoDetail, imgSrcGetBase64 } from "common/js/api";
export default {
  name: "Fund",
  components: {
    DetailLogo,
  },
  data() {
    return {
      businessData: [
        {
          businessNam: "银行",
          businessLogo: [
            {
              imgUrl: require("../../assets/images/_001.png"),
            },
            {
              imgUrl: require("../../assets/images/_002.png"),
            },
            {
              imgUrl: require("../../assets/images/_003.png"),
            },
            {
              imgUrl: require("../../assets/images/_004.png"),
            },
          ],
        },
        {
          businessNam: "会计师事务所",
          businessLogo: [
            {
              imgUrl: require("../../assets/images/_005.png"),
            },
            {
              imgUrl: require("../../assets/images/_006.png"),
            },
            {
              imgUrl: require("../../assets/images/_007.png"),
            },
            {
              imgUrl: require("../../assets/images/_008.png"),
            },
          ],
        },
        {
          businessNam: "律师事务所",
          businessLogo: [
            {
              imgUrl: require("../../assets/images/_009.png"),
            },
            {
              imgUrl: require("../../assets/images/_010.png"),
            },
            {
              imgUrl: require("../../assets/images/_011.png"),
            },
            {
              imgUrl: require("../../assets/images/_012.png"),
            },
          ],
        },
        {
          businessNam: "证券公司",
          businessLogo: [
            {
              imgUrl: require("../../assets/images/_013.png"),
            },
            {
              imgUrl: require("../../assets/images/_014.png"),
            },
            {
              imgUrl: require("../../assets/images/_015.png"),
            },
            {
              imgUrl: require("../../assets/images/_016.png"),
            },
          ],
        },
      ],
      dialogVisible: false,
      title: "企业详情",
      logoId: "",
      detailData: [],
    };
  },
  created() {
    this.getAgencyList();
    // this.getUrl();
  },
  methods: {
    imgDetail(el) {
      this.dialogVisible = true;
      this.logoId = el.id;
      this.getDetail();
    },
    async getDetail() {
      const { result } = await logoDetail(this.logoId);
      this.detailData = result;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    async getAgencyList() {
      const { result } = await agencyList();
      //this.businessData = result;
      this.businessData = result.filter((item) => {
        return item.agencyType !== "";
      });
      console.log(this.businessData);
      const i = 1;
      if (i < this.businessData.length - 1) {
        var tempOption = this.businessData[i + 1];
        this.$set(this.businessData, i + 1, this.businessData[i]);
        this.$set(this.businessData, i, tempOption);
      }
      console.log("length",this.businessData.length)
      if (this.businessData.length > 0) {
        // console.log("1")
        this.businessData.forEach((element) => {
          // console.log("2")
          if(element.data.length>0){
            element.data.forEach(async (val) => {
              let a =await imgSrcGetBase64(val.logo_url);
              // console.log("3")
              this.$set(val,"logo_url",a.result);
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.business_title {
  border-left: 8px solid #3165ff;
  font-size: 24px;
  color: #0f1824;
  font-weight: bold;
  padding-left: 10px;
  margin: 0 0 15px;
}
.trademark_box {
  padding: 20px 42px;
}
.trademark {
  display: inline-block;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.034);
  max-width: 240px;
  margin: 0 20px 20px 0;
  box-shadow: 0 1px 4px 0 rgba(53, 56, 72, 0.06);
}
.trademark img {
  max-width: 100%;
}
</style>
